import {HTTP} from '@/CallAPI'
export default {
  getListDocument (page = 1, per_page = '', status = '', search = '', sort = '', group_id = '') {
    return HTTP.get('documents', {
      params: {
        page,
        per_page,
        status,
        search,
        sort,
        grp_doc_id: group_id
      }
    })
  },

  showDocument (document) {
    return HTTP.get('documents/' + document.id)
  },

  updateDocument (document) {
    return HTTP.post('documents/' + document.get('id'), document)
  },

  createDocument (document) {
    return HTTP.post('documents', document)
  },

  destroyDocument (document) {
    return HTTP.delete('documents/' + document.id)
  },

  approvalDocument (document) {
    return HTTP.post('documents/' + document.id + '/approval')
  },

  rejectDocument (document) {
    return HTTP.post('documents/' + document.id + '/rejection')
  },

  getVersionDocument (document) {
    return HTTP.get('documents/' + document.id + '/versions')
  },

  destroyVersionDocument (document, version) {
    return HTTP.delete('documents/' + document.id + '/versions/' + version.id)
  },

  createVersionDocument (document, version) {
    return HTTP.post('documents/' + document.id + '/versions', version)
  },

  multiDestroyDocument (ids) {
    return HTTP.delete('multi-destroy-documents', {params: {
      ids: ids
    }})
  },

  multiApprovalDocument (ids) {
    return HTTP.put('multi-approval-documents', {
      ids: ids
    })
  },

  multiRejectDocument (ids) {
    return HTTP.put('multi-rejection-documents', {
      ids: ids
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/document.js